import React from "react";
import { Image } from "antd";
import UserIcon from "../../assets/images/icons/userLogo.svg";

function InfoRow({ label, value }) {
  return (
    <div className="partnerInfoRow">
      <div className="partnerInfoCol"><label>{label}</label></div>
      <div className="partnerInfoCol"> <p>{value || "-"}</p></div>
    </div>
  );
}

function PartnerDetailsView({ partnerData }) {
  return (
    <div className="partner-details">
      <div className="">
        <InfoRow label="Partner name:" value={partnerData?.name} />
        <InfoRow label="Website:" value={partnerData?.website} />
        <div className="partnerInfoRow">
          <div className="partnerInfoCol"><label>Logo:</label></div>
          <div className="partnerInfoCol"><Image src={partnerData?.mediaLink || UserIcon} alt="partner-logo" preview={false} width={100} /></div>
        </div>

        <InfoRow label="Address:" value={partnerData?.address} />
        <InfoRow label="Mobile number:" value={partnerData?.mobileNumber} />
        <InfoRow label="Site name:" value={partnerData?.siteName} />
        {/* <InfoRow label="Membership ad title:" value={partnerData?.membershipAdTitle} />
        <InfoRow label="Membership ad description:" value={partnerData?.membershipAdDescription} />
        <InfoRow label="Membership link:" value={partnerData?.membershipLink} /> */}
        <InfoRow label="Organisation login  description:" value={partnerData?.description} />
        <InfoRow label="End user home page description:" value={partnerData?.endUserPageDescription} />


        <div className="partnerInfoRow">
          <div className="partnerInfoCol"><label>Wallpaper:</label></div>
          <div className="partnerInfoCol"><Image src={partnerData?.wallpaper || UserIcon} alt="partner-wallpaper" preview={false} width={100} /></div>
        </div>
        
        {/* <InfoRow label="Wallpaper for website:" value={partnerData?.wallpaperToggle ? "Yes" : "No"} /> */}
        <InfoRow label="Partner type:" value={partnerData?.partnerType || "Not specified"} />
      </div>
    </div>
  );
}

export default PartnerDetailsView;